import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { ShortNamePipe } from './short-name.pipe';
import { MarkdownPipe } from './markdown.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { StripHtmlPipe } from './strip-html.pipe';

@NgModule({
  declarations: [FilterPipe, SearchPipe, ShortNamePipe, MarkdownPipe, SafeHtmlPipe, StripHtmlPipe],
  imports: [CommonModule],
  exports: [FilterPipe, SearchPipe, ShortNamePipe, MarkdownPipe, SafeHtmlPipe, StripHtmlPipe]
})

export class PipeModule { }
